import axios from 'axios'

// 创建axios实例
const api = axios.create({
    // baseURL: '/api', //mock接口地址
    baseURL: 'http://localhost:8080/api', //本地调试地址
    //  baseURL: 'http://10.253.30.23:8080/api', //局域网地址
    //  baseURL: 'http://10.252.40.18:8080/api', //局域网地址
    // baseURL: 'https://api-paz8t4sez3zd3bw4.aistudio-app.com/api', //真实接口地址
    timeout: 10 * 1000, // 请求超时10秒
    headers: {
        'Content-Type': 'application/json'
    }
})

// 请求拦截器
api.interceptors.request.use(config => {
    const token = localStorage.getItem('token')
    if (token) {
        config.headers.Authorization = `Bearer ${token}`
    }
    return config
}, error => {
    return Promise.reject(error)
})

// 响应拦截器
api.interceptors.response.use(response => {
    const res = response.data
    if (res.code !== 200) {
        console.error(res.message || '请求错误')
        return Promise.reject(new Error(res.message || '请求错误'))
    }
    return res
}, error => {
    console.error('请求失败: ' + JSON.stringify(error.response.data))
    return Promise.reject(error)
})

export const Api = {
    login(data) {
        return api.post('/login', data)
    }, logout() {
        return api.post('/logout')
    }, register(data) {
        return api.post('/register', data)
    },

    // 患者相关接口
    getPatient(id) { //deprecated
        return api.get(`/patients/${id}`)
    }, fetchPatients() {
        return api.get('/fetchPatients')
    }, fetchPatientDetail(patientId) {
        return api.get(`/fetchPatientDetail/${patientId}`)
    },

    // 脑电分析记录相关接口
    fetchRecords(recordId) {
        return api.get(`/fetchRecords/${recordId}`)
    }, uploadFile(formData) {
        return api.post("/upload", formData, {
            headers: {"Content-Type": "multipart/form-data"}, timeout: 10 * 60 * 1000, // 10分钟，只对这个请求生效
        });
    },
    
    submitTreatmentPlan(planData) {
        return api.post('/treatment-plans', planData)
    },

    getTreatmentPlans(patientId) {
        return api.get(`/treatment-plans/${patientId}`)
    },
    getTreatmentPlanById(planId) {
        return api.get(`/treatment-plan/${planId}`)
    },
    deleteTreatmentPlan(planId) {
        return api.delete(`/treatment-plan/${planId}`)
    },
}
export default {
    Api: Api,
}